import React, {createContext, useEffect} from 'react';
import PropTypes from 'prop-types';
import { createConsumer } from '@rails/actioncable';
import { getAuthorizationToken } from 'services/authorization_token';
import { CABLE_DOMAIN, CABLE_PATH, CABLE_PROTOCOL } from 'constants';
import BackSocketContext from 'contexts/back_socket/context';

const BackSocketProvider = ({ children }) => {
    const cable = createConsumer(
        `${CABLE_PROTOCOL}://${CABLE_DOMAIN}${
            CABLE_PATH !== '' ? `/${CABLE_PATH}` : ''
        }?authorization_token=${getAuthorizationToken()}`,
    );

    return (
        <BackSocketContext.Provider value={{ cable }}>
            {children}
        </BackSocketContext.Provider>
    );
};

BackSocketProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired,
};

export default BackSocketProvider;